import { render, staticRenderFns } from "./EditorCadastroProposta.vue?vue&type=template&id=9ec84162"
import script from "./EditorCadastroProposta.vue?vue&type=script&lang=js"
export * from "./EditorCadastroProposta.vue?vue&type=script&lang=js"
import style0 from "./EditorCadastroProposta.vue?vue&type=style&index=0&id=9ec84162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports